// extracted by mini-css-extract-plugin
module.exports = {"container__cart":"CartList_container__cart__vc5dD","button":"CartList_button__XOysR","close":"CartList_close__38177","open":"CartList_open__UotKl","user":"CartList_user__2othV"};